import ArrowBack from 'components/Icons/ArrowBack';
import PDChecks from 'components/Icons/PDChecks';
import PDNotes from 'components/Icons/PDNotes';
import PDSecure from 'components/Icons/PDSecure';
import Link from 'next/link';

const PDTermsAndConditions = ({ setIsTermsVisible, startPDMeter }: { setIsTermsVisible: any; startPDMeter: any }) => {
    return (
        <div className='xs:absolute h-full w-full z-50 bg-white  overflow-y-auto'>
            <div className='px-[14px] md:pt-[15px] pt-[25px] cursor-pointer' onClick={() => {
                setIsTermsVisible(false);
            }}>
                <ArrowBack />
            </div>
            <div className='md:px-[30px] px-[15px] mt-[10px]'>
                <h3 className='font-semibold text-[24px] text-[#2A2A2A] text-left'>Online Pupillary Distance Measurement Tool</h3>

                <p className='text-[14px] font-normal text-[#2A2A2A] mt-[10px] text-left'>The Online PD Meter is designed to measure the distance between a person’s pupils. Using an AI-based algorithm, the PD Meter determines the distance of the camera and calculates the distance between the eyes while the user looks at the phone’s camera. It provides the pupillary distance (PD) measurement in millimeters, rounded to 0.5mm. Additionally, the PD Meter estimates the distance between the eyes when the user looks at a distant object. Our online Pupillary Distance (PD) tool is provided for informational purposes only. While we strive for accuracy, the measurements obtained through this tool may not always be precise due to factors such as screen resolution, device calibration, and user error. </p>

                <div className='flex items-center justify-start mt-[17px] gap-[8px]'>
                    <PDSecure />
                    <p className='text-[#2A2A2A] font-semibold text-[16px] text-left'>Private Session:</p>
                </div>

                <p className='text-[14px] font-normal text-[#2A2A2A] mt-[10px] text-left'>During your use of the tool, please be assured that the video feed is neither recorded nor transmitted to our servers. All processing occurs locally and privately on your device. Your privacy and data security are our top priorities.</p>

                <div className='flex items-center justify-start mt-[17px] gap-[8px]'>
                    <PDChecks />
                    <p className='text-[#2A2A2A] font-semibold text-[16px]'>Special Terms:</p>
                </div>

                <div className=' bg-white'>
                    <ul className='list-disc text-[14px] font-normal text-[#2A2A2A] pl-[25px] mt-[10px] text-left'>
                        <li>Online PD Meter may not provide accurate results under certain lighting conditions.</li>
                        <li>Online PD Meter operates on genuine devices running Android or iOS operating systems only. Minimum mobile OS requirements: Android 9.0 and above; iOS 15 and above.</li>
                        <li>PD Meter requires a minimum mobile front camera resolution of 6 megapixels.</li>
                        <li>The tool requires recent iOS or Android devices with properly functioning components: front camera, speakers, and touch screen.</li>
                    </ul>
                </div>

                <div className='flex items-center justify-start mt-[17px] gap-[8px]'>
                    <PDNotes />
                    <p className='text-[#2A2A2A] font-semibold text-[16px]'>Important Notes:</p>
                </div>

                <p className='text-[14px] font-normal text-[#2A2A2A] mt-[10px] text-left'>If your dioptric value exceeds +/- 4 dioptres, we recommend visiting one of our stores for accurate pupillary distance (PD) and ocular height measurements. You can drop by or book an appointment online in advance. Regardless of your prescription, you are always welcome to visit our stores for PD measurements and further assistance.</p>

                <p className='text-[14px] font-normal text-[#616161] mt-[10px] text-left'>Disclaimer: By using this tool, you agree that we shall not be liable for any inaccuracies or discrepancies in the measurements obtained. Use the measurements obtained through this tool at your own discretion.</p>
            </div>

            <div className='px-[15px] md:h-[70px] flex items-center justify-center mt-[10px] gap-[8px] md:flex-row flex-col md:shadow-pd mb-[25px] md:mb-0'>
                <button className='md:h-[40px] h-[48px] md:w-[190px] w-full text-[14px] font-medium rounded-[10px] bg-[#2A2A2A] text-white order-1 md:order-2' onClick={() => {
                    startPDMeter();
                }}>Start PD Calculator</button>
                <button className='md:h-[40px] h-[48px] md:w-[190px] w-full text-[#2A2A2A] text-[14px] font-medium rounded-[10px] order-2 md:order-1' style={{ border: '1px solid #cacaca' }} onClick={() => {
                    setIsTermsVisible(false);
                }}>Back</button>
            </div>

        </div>
    );
};

export default PDTermsAndConditions;
